module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("This book honors my wonderful wife Melisa.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("We met through running. We have run many miles together in some extraordinary places in the world. Her tireless and unselfish support of my coaching over almost thirty years is a constant source of inspiration to me. Being “Mrs. Coach” is not easy. The endless hours I spent buried in spreadsheets, and the time I spent on Saturdays at invitationals was time not spent with her. The amount of grace required for planning personal vacations and trips around my coaching schedule is a testament to how special a woman she is—a special wife. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Special")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Thanks for always believing in me and supporting me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 69
// module chunks = 0